import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/**
 * 日付やタイトルなどの情報をリスト表示するコンポーネント
 * @param props
 * @returns
 */
export const InfoList = (props) => {
    const { children, className = '' } = props;
    return (_jsx("ul", Object.assign({ className: clsx('flex flex-col', 'w-full', 'divide-x-0 divide-y divide-solid divide-gray-100', className) }, { children: children })));
};
